exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".more-info-lettering {\n  color: white;\n  background-color: dimgrey;\n  padding: 10px;\n  border-radius: 5px;\n}\n.notification p a,\n.notification li a {\n  color: white;\n  font-weight: bold;\n  text-decoration: underline;\n}\n.notification p a:hover,\n.notification li a:hover {\n  text-decoration: none;\n}\n", ""]);

// exports
